import CryptoJS from "crypto-js";
import AsyncValidator from "async-validator";

/* 日期转化 */
export function formatDate(NewDtime) {
  let datetime = new Date(NewDtime);
  let year = datetime.getFullYear();
  let month = (datetime.getMonth() + 1).toString(); //js从0开始取
  let date = datetime.getDate().toString();
  let hour = datetime.getHours().toString();
  let minutes = datetime.getMinutes().toString();
  let second = datetime.getSeconds().toString();

  if (parseInt(month) < 10) {
    month = "0" + month;
  }
  if (parseInt(date) < 10) {
    date = "0" + date;
  }
  if (parseInt(hour) < 10) {
    hour = "0" + hour;
  }
  if (parseInt(minutes) < 10) {
    minutes = "0" + minutes;
  }
  if (parseInt(second) < 10) {
    second = "0" + second;
  }
  let time = year + "-" + month + "-" + date + " " + hour + ":" + minutes + ":" + second; //2009-06-12 17:18:05
  return time;
}

// 格式化时间
export const formatDateReg = (d, fmt) => {
  let o = {
    "M+": d.getMonth() + 1, //月份
    "d+": d.getDate(), //日
    "h+": d.getHours(), //小时
    "m+": d.getMinutes(), //分
    "s+": d.getSeconds(), //秒
    "q+": Math.floor((d.getMonth() + 3) / 3), //季度
    S: d.getMilliseconds(), //毫秒
  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (d.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (let k in o) if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
  return fmt;
};

export function deepCopyRef(obj) {
  let _obj = {}; //标记一个对象，使其永远不会转换为 proxy。返回对象本身。
  return Object.assign(_obj, obj);
}
export function formatDateYear(dateString) {
  if (!dateString) return;
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = date.getMonth() + 1; // 月份从0开始，需要加1
  const day = date.getDate();

  // 确保月份和日期是两位数
  const formattedMonth = month < 10 ? `0${month}` : month;
  const formattedDay = day < 10 ? `0${day}` : day;

  return `${year}年${formattedMonth}月${formattedDay}日`;
}

// 示例用法

function getCookie(name) {
  let reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  let arr = document.cookie.match(reg);
  if (arr) return unescape(arr[2]);
  else return null;
}

function DateStrKey() {
  let date = new Date();
  let y = date.getFullYear().toString();
  let m = (date.getMonth() + 1).toString();
  let d = date.getDate().toString();

  if (parseInt(m) < 10) {
    m = "0" + m;
  }
  if (parseInt(d) < 10) {
    d = "0" + d;
  }
  return `${y}-${m}-${d}`;
}

// 加密
export const encryptDES = (message, desKey) => {
  const key = desKey || `${getCookie("JSESSIONID")}-${DateStrKey()}`;
  console.log(key);
  const keyHex = CryptoJS.enc.Utf8.parse(key);
  if (message) {
    let encrypt = CryptoJS.DES.encrypt(message, keyHex, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    });
    return encrypt.toString();
  } else {
    return "";
  }
};

// 解密
export const decryptDES = (ciphertext) => {
  const key = `${getCookie("JSESSIONID")}-${DateStrKey()}`;
  const keyHex = CryptoJS.enc.Utf8.parse(key);
  if (ciphertext) {
    let decrypted = CryptoJS.DES.decrypt(ciphertext, keyHex, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
  } else {
    return "";
  }
};

/**
 * @author 伟健 / 张
 * @name 根据key赋值
 * @param
 * @return original
 */
const hasOwnProperty = Object.prototype.hasOwnProperty;
export const setval = (original, _from) => {
  for (let key in original) {
    if (hasOwnProperty.call(_from, key)) {
      original[key] = _from[key];
    }
  }
  return original;
};

/**
 * @author 伟健 / 张
 * @name 清空对象值
 * @param
 * @return
 */
export const reset = (original) => {
  for (let key in original) {
    original[key] = "";
  }
  return original;
};

export let throttle = function (action, delay) {
  let timeout = null;
  let lastRun = 0;
  return function () {
    if (timeout) {
      return;
    }
    let elapsed = Date.now() - lastRun;
    let context = this;
    let args = arguments;
    let runCallback = function () {
      lastRun = Date.now();
      timeout = false;
      action.apply(context, args);
    };
    if (elapsed >= delay) {
      runCallback();
    } else {
      timeout = setTimeout(runCallback, delay);
    }
  };
};

export let requiredVal = function () {
  let arg = [...arguments];
  return !arg.some((el) => {
    return el === "" || el === undefined || el === null || el.length == 0;
  });
};

export let dateFormat = (date, fmt) => {
  if (!date) return "";

  let o = {
    "M+": date.getMonth() + 1, // 月份
    "d+": date.getDate(), // 日
    "h+": date.getHours(), // 小时
    "m+": date.getMinutes(), // 分
    "s+": date.getSeconds(), // 秒
    "q+": Math.floor((date.getMonth() + 3) / 3), // 季度
    S: date.getMilliseconds(), // 毫秒
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
  }
  for (let k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
    }
  }
  return fmt;
};
/**
 * @author 伟健 / 张
 * @name 合并对象
 * @param
 * @return
 */
export const extend = (vm, to, _from) => {
  for (let key in _from) {
    if (to[key] == undefined || to[key] == null || to[key] === "") {
      vm.$set(to, key, _from[key]);
    }
  }
  return to;
};

export const downloadFileFromUrl = async function (url, fileName) {
  try {
    const fileExtension = url.split(".").pop();
    window.open(`${url}?attname=${fileName}.${fileExtension}`, "_blank");
  } catch (error) {
    console.error("Error downloading file:", error);
  }
};

export const getPosition = (obj) => {
  var el = obj.getBoundingClientRect();
  var top = el.top - document.documentElement.clientTop + document.documentElement.scrollTop, //document.documentElement.clientTop 在IE67中始终为2，其他高级点的浏览器为0
    bottom = el.bottom,
    left = el.left - document.documentElement.clientLeft + document.documentElement.scrollLeft, //document.documentElement.clientLeft 在IE67中始终为2，其他高级点的浏览器为0
    right = el.right,
    width = el.width || right - left, //IE67不存在width 使用right - left获得
    height = el.height || bottom - top;

  return {
    y: top,
    right: right,
    bottom: bottom,
    x: left,
    width: width,
    height: height,
  };
};

// 获取滚动条距离
export const getScroll = (direction, el) => {
  if (el) {
    return el[direction];
  }
  return document.body[direction] || document.documentElement[direction];
};

export const classNameToArray = (cls = "") => cls.split(" ").filter((item) => !!item.trim());

export const addClass = (el, cls) => {
  if (!el || !cls.trim()) return;
  el.classList.add(...classNameToArray(cls));
};

export const removeClass = (el, cls) => {
  if (!el || !cls.trim()) return;
  el.classList.remove(...classNameToArray(cls));
};

export const remove = (arr, item) => {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1);
    }
  }
};

export const browserType = () => {
  return window.navigator.userAgent;
};
export let isIE = function () {
  if (!!window.ActiveXObject || "ActiveXObject" in window) return true;
  else return false;
};

export let openUrl = (url) => {
  if (!url) return;
  let reg = /#[\/\w]+\?/;

  if (url.match(reg)) {
    if (url.match(reg)[0] == window.location.href.match(reg) && window.location.href.match(reg)[0]) {
      return;
    }
  }

  if (isIE()) {
    try {
      window.location.href = url;
      false;
    } catch (e) {
      console.log(e);
      location.assign(encodeURIComponent(url));
    }
  } else {
    window.location.href = url;
  }
};
export const isString = (val) => typeof val === "string";
/**
 * @author 伟健 / 张
 * @name 检查是否为空
 * @param
 * @return
 */
export const required = () => {
  let arg = [...arguments];
  return !arg.some((el) => {
    return el == "" || el == undefined || el == null;
  });
};
/**
 * @author 伟健 / 张
 * @name  传入对象，键，返回对应值
 * @param obj keys
 * @return obj[]
 */
export const keysRetrievalObj = (obj, keys) => {
  if (obj && keys) {
    return [];
  }
};

/* 
递归对象,并获取对象指定 键的值
*/

export const recursiveSearch = (obj, key, key1) => {
  let res = [];
  function main(obj, key, key1) {
    if (obj[key1]) {
      res.push(obj[key1]);
    }
    for (let i = 0; i < obj.length; i++) {
      if (obj[i][key]) {
        main(obj[i][key], key, key1);
      } else {
        main(obj[i], key, key1);
      }
    }
  }
  main(obj, key, key1);
  return res;
};

export let base64toFile = (dataurl, filename = "file") => {
  let arr = dataurl.split(",");
  let mime = arr[0].match(/:(.*?);/)[1];
  let suffix = mime.split("/")[1];
  let bstr = atob(arr[1]);
  let n = bstr.length;
  let u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  let File = window.File;
  try {
    new File([], "");
  } catch (e) {
    console.log(e);
    File = class File extends Blob {
      constructor(chunks, filename, opts = {}) {
        super(chunks, opts);
        this.lastModifiedDate = new Date();
        this.lastModified = +this.lastModifiedDate;
        this.name = filename;
      }
    };
  }
  return new File([u8arr], `${filename}.${suffix}`, {
    type: mime,
  });
};
/**
 * @author 伟健 / 张
 * @name 检查 formData 参数
 */
export let checkFormData = (formData, rules, callback) => {
  if (!rules || !formData) return;

  let valid = true;
  let validateMessage = "";
  Object.keys(formData).forEach((key) => {
    let descriptor = {};
    if (!rules[key] || !valid) return;
    descriptor[key] = rules[key];
    let validator = new AsyncValidator(descriptor);
    let model = {};
    model[key] = formData[key];
    // console.log(model[key]);
    validator.validate(model, { firstFields: true }, (errors) => {
      let validateState = !errors ? "success" : "error";
      validateMessage = errors ? errors[0].message : "";
      if (validateState == "error") {
        valid = false;
      }
    });
  });
  callback(valid, validateMessage);
};

export const flattenObject = (obj, parentKey = "", result = {}) => {
  for (let key in obj) {
    if (hasOwnProperty.call(obj, key)) {
      let newKey = parentKey ? `${parentKey}.${key}` : key;
      if (typeof obj[key] === "object" && !Array.isArray(obj[key])) {
        // 如果是对象，则递归调用
        flattenObject(obj[key], newKey, result);
      } else if (Array.isArray(obj[key])) {
        // 如果是数组，则遍历数组元素
        obj[key].forEach((item, index) => {
          if (typeof item === "object") {
            // 数组中的元素也是对象
            flattenObject(item, `${newKey}[${index}]`, result);
          } else {
            // 普通数组元素
            result[`${newKey}[${index}]`] = item;
          }
        });
      } else {
        // 基本类型值
        result[newKey] = obj[key];
      }
    }
  }
  return result;
};
export const copyText = (value, fn) => {
  if (!value) {
    return;
  }
  var textArea = document.createElement("textarea");
  textArea.style.background = "transparent";
  textArea.value = value;
  document.body.appendChild(textArea);
  textArea.select();
  try {
    document.execCommand("copy");
    fn && fn();
    // this.$message.success({
    //   message: '复制成功',
    // });
  } catch (err) {
    console.log(err);
    console.log("Oops, unable to copy");
  }
  document.body.removeChild(textArea);
};

export const isLessThan30Days = (date) => {
  // 确保输入的是日期对象或可以转换为日期对象的字符串

  if (!date) return false;
  const d1 = new Date(date);
  const d2 = new Date();

  // 计算时间差（以毫秒为单位）
  const timeDiff = Math.abs(d1 - d2);

  // 将时间差转换为天数
  const dayDiff = timeDiff / (1000 * 60 * 60 * 24);

  // 判断天数差是否小于7天
  return dayDiff <= 7;
};


export const isLessThan7Days = (date) => {
  // 确保输入的是日期对象或可以转换为日期对象的字符串

  if (!date) return false;
  const d1 = new Date(date);
  const d2 = new Date();

  // 计算时间差（以毫秒为单位）
  const timeDiff = d1 - d2;

  // 将时间差转换为天数
  const dayDiff = timeDiff / (1000 * 60 * 60 * 24);

  // 判断天数差是 大于于7天
  return dayDiff > 7;
};

/**
 * @author 伟健 / 张
 * @name 倒计时
 */
export let countDown = function (key, cb) {
  if (key) {
    let num = this[key];

    this[key]--;
    let time = setInterval(() => {
      this[key]--;
      if (this[key] <= 0) {
        clearInterval(time);
        cb && cb();
        this[key] = num;
      }
    }, 1000);
  }
};
/**
 * @author 伟健 / 张
 * @name 要将数字金额转换为中文大写
 */
export let digitUppercase = function (n) {
  const fraction = ["角", "分"];
  const digit = ["零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖"];
  const unit = [
    ["元", "万", "亿"],
    ["", "拾", "佰", "仟"],
  ];

  let num = Math.abs(n);
  let s = "";

  for (let i = 0; i < fraction.length; i++) {
    s += (digit[Math.floor(num * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(/零./, "");
  }
  s = s || "整";
  num = Math.floor(num);

  for (let i = 0; i < unit[0].length && num > 0; i++) {
    let p = "";
    for (let j = 0; j < unit[1].length && num > 0; j++) {
      p = digit[num % 10] + unit[1][j] + p;
      num = Math.floor(num / 10);
    }
    s = p.replace(/(零.)*零$/, "") + unit[0][i] + s;
  }

  return s
    .replace(/(零.)*零元/, "元")
    .replace(/(零.)+/g, "零")
    .replace(/^整$/, "零元整");
};
